import Defiling from "./defiling.js";
import Button from "./button.js";
import ScrollTo from "./scrollto.js";

const defilingTexts = document.querySelectorAll("[data-defiling]");

defilingTexts.forEach((defilingText) => {
  new Defiling(defilingText);
});

const button = document.querySelector("[data-button]");

new Button(button);

const scrolltoLink = document.querySelector("[data-scrollto]");

new ScrollTo(scrolltoLink);
